<template>
	<div class="layout-footer">
		<span class="footer-text" style="margin-right: 5px">IKPonto - Bate Ponto -</span>		
		<span class="footer-text" style="margin-left: 5px">Info Kings Sistemas de ponto e acesso LTDA</span>
	</div>
</template>

<script>
	export default {
		name: "AppFooter"
	}
</script>
	
<style scoped>

</style>